KXL.module('Components.Video', function (Video, KXL, Backbone, Marionette, $, _) {
	Video.Controller = {
		getVideo: function (options){
			return new Video.View(options);
		}
	};
});
